import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { handleQuerySuccess } from '../../../../../hooks/useQuriesSuccess';
import { apiRequest } from '../../../../../Services/Common/ApiRequest';
import Global from '../../../../../Services/Common/Global';
import { mapParamsBySchema } from '../../../../../util';
import { TRA_NEW_01_Schema } from './TRA_NEW_01_Schema';
import useSearchMutaion from '../../../../../hooks/apis/useSearchMutaion';

export const useSearch1 = (options = {}) => {
  const { onSuccess, enabled = true } = options;
  const params = mapParamsBySchema(TRA_NEW_01_Schema.mapper.search1);

  const query = useQuery({
    queryKey: ['Training', 'getTraNew01R1', params],
    queryFn: () =>
      apiRequest('post', Global.urls.Training.getTraNew01R1, params),
    enabled,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};

export const useSearch2 = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(TRA_NEW_01_Schema.mapper.search2, context);
    return apiRequest('post', Global.urls.Training.getTraNew01R2, params);
  }, successOptions);
};

export const useSearch3 = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(TRA_NEW_01_Schema.mapper.search3, context);
    return apiRequest('post', Global.urls.Member.getMemBasicR1, params);
  }, successOptions);
};

export const useSearch4 = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(TRA_NEW_01_Schema.mapper.search1, context);
    return apiRequest('post', Global.urls.Training.getTraNew01R1, params);
  }, successOptions);
};
